import validator from 'validator';
import moment from 'moment';

export const isEmail = (email) => {
    return validator.isEmail(email) ? null : `"${email}" is not a valid email.`;
};

export const isRequired = (value) => {
    return value != null && value !== '' ? null : 'This field is required.';
};

export const isRequiredIfTrue = (value, booleanValue, errorMessage) => {
    if(booleanValue === true) {
        return value != null && value !== '' ? null : errorMessage || 'This field is required.';
    } else {
        return null;
    }

};

export const isRequiredIfOther = (value, valueOfSelect) => {
    if(valueOfSelect != null && valueOfSelect.toLowerCase() === 'other') {
        return validator.isEmpty(value) === false ? null : 'This field is required.';
    } else {
        return true;
    }
};

export const isRequiredIfSiblingNotNull = (value, valueOfSibling, nameOfSibling) => {
    if(valueOfSibling) {
        return validator.isEmpty(value) === false ? null : `This field is required when ${nameOfSibling} has a value.`;
    } else {
        return null;
    }
};

export const isPhoneNumber = (value) => {
    let onlyNumbers = '';
    if(value != null) {
        onlyNumbers = value.replace(/\D/g, '');
    }
    return value != null && (onlyNumbers.length === 9 || onlyNumbers.length === 10) ? null : `${value} is not a valid phone number`;
};

export const isDate = (value) => {
    return validator.isDate(new Date(value).toString()) ? null : `${value} is not a valid date.`;
};

export const isDateInFuture = (value) => {
    return moment(value).isSameOrAfter(moment(), 'day') ? null : 'Please choose a date that is in the future.';
};

export const isTrue = (value, message) => {
    return value === true ? null : message
};

export const isEqual = (value1, value2, message) => {
    return value1 === value2 ? null : message;
};

export const isGreaterThanOrEqualTo = (value1, value2, message) => {
    return value1 >= value2 ? null : message;
};



// WEBPACK FOOTER //
// ./src/utils/validations.js